import React from 'react';
import styled from 'styled-components';
import tw from 'twin.macro';
import Skeleton from '../Skeleton';

const PageContainer = styled.div`
  ${tw`w-full px-4`}
`;

const ContentContainer = styled.div`
  ${tw`mx-auto w-full max-w-md`}
`;

const FeesContainer = styled.div`
  ${tw`space-y-2`}
`;

const FeeCardSkeleton = styled.div`
  ${tw`relative flex cursor-pointer rounded-lg bg-bg-secondary py-4 px-5 shadow-card transition`}
`;

const RadioContentSkeleton = styled.div`
  ${tw`flex w-full items-center justify-between`}
`;

const PlanInfoSkeleton = styled.div`
  ${tw`text-sm/6 w-full max-w-full min-w-0 box-border`}
`;

const PlanNameSkeleton = styled(Skeleton)`
  ${tw`h-6 w-48 mb-2`}
`;

const PlanDetailsSkeleton = styled.div`
  ${tw`flex gap-2`}
`;

const DetailSkeleton = styled(Skeleton)`
  ${tw`h-4 w-16`}
`;

const SwitchSkeleton = styled(Skeleton)`
  ${tw`h-6 w-12 rounded-full`}
`;

const InputContainerSkeleton = styled.div`
  ${tw`max-w-full mt-4 bg-bg-secondary p-4`}
`;

const InputLabelSkeleton = styled(Skeleton)`
  ${tw`h-4 w-24 mb-2`}
`;

const InputFieldSkeleton = styled(Skeleton)`
  ${tw`h-[44px] w-full rounded-lg`}
`;

const TextAreaSkeleton = styled(Skeleton)`
  ${tw`h-[100px] w-full rounded-lg`}
`;

const ButtonSkeleton = styled(Skeleton)`
  ${tw`h-12 w-full rounded-md mt-4`}
`;

const TripFeePageSkeleton: React.FC = () => {
  return (
    <PageContainer>
      <ContentContainer>
        <FeesContainer>
          {/* Multiple fee cards */}
          {Array(5)
            .fill(0)
            .map((_, index) => (
              <FeeCardSkeleton key={index}>
                <RadioContentSkeleton>
                  <PlanInfoSkeleton>
                    <PlanNameSkeleton />
                    <PlanDetailsSkeleton>
                      <DetailSkeleton />
                      <DetailSkeleton />
                    </PlanDetailsSkeleton>
                  </PlanInfoSkeleton>
                  <SwitchSkeleton />
                </RadioContentSkeleton>
              </FeeCardSkeleton>
            ))}
        </FeesContainer>

        {/* Selected fee details */}
        <InputContainerSkeleton>
          <InputLabelSkeleton />
          <InputFieldSkeleton />
        </InputContainerSkeleton>

        <InputContainerSkeleton>
          <InputLabelSkeleton />
          <InputFieldSkeleton />
        </InputContainerSkeleton>

        <InputContainerSkeleton>
          <InputLabelSkeleton />
          <TextAreaSkeleton />
        </InputContainerSkeleton>

        <ButtonSkeleton />
      </ContentContainer>
    </PageContainer>
  );
};

export default TripFeePageSkeleton;
